import { queryKeys } from '../../queries/queryKeys';
import { useApiQuery } from '../../queries/useApiQuery';
import { getBlob } from '../../queries';

export const useImageQuery = (id: string | null | undefined) => {
    const imageId = id || undefined;

    const query = useApiQuery<Blob>({
        queryKey: imageId ? queryKeys.image.single(imageId) : queryKeys.image.singleAll(),
        queryFn: () => getBlob(`images/${imageId}`),
        queryOptions: { enabled: !!imageId, refetchOnWindowFocus: false },
    });

    return {
        ...query,
    };
};
